import { SelectOptionProps } from '@acceso/design-system';

import { usePortainerGroups } from '../api/get-portainer-groups';

export function usePortainerGroupOptions(): SelectOptionProps<string>[] {
  const { data: portainerGroups = [] } = usePortainerGroups();
  const options: SelectOptionProps<string>[] = portainerGroups.map(portainerGroup => ({
    label: portainerGroup.name,
    value: portainerGroup.id,
  }));

  return options;
}
